import api from "./api.service";
import { adminTokenService } from "./admin.token.service";

export interface AdminUserRole {
    id: number;
    roleName: string;
    isSuperAdmin?: boolean;
}

export interface AdminUser {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    status: number;
    roles: AdminUserRole[];
}

export interface GetAdminUsersParams {
    page?: number;
    pageSize?: number;
    status?: number;
    idRole?: number;
    SearchString?: string;
}

export interface CreateUserData {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    idRoles: number[];
}

export interface UpdateUserData {
    idUser: number;
    firstName: string;
    lastName: string;
    password: string;
    idRoles: number[];
}

export interface ChangeUserStatusData {

    idUser: number;
    status: number;
}



export interface GetAdminUsersResponse {
    statusCode: number;
    message: string;
    data: AdminUser[];
    pagination: {
        totalCount: number;
        page: number;
        pageSize: number;
        totalPages: number;
    };
}

class AdminUserService {
    /**
     * Fetches a list of users for administration purposes.
     * @param params Filtering and pagination parameters.
     * @returns A promise with the users data and pagination info.
     */
    async getUsers(params?: GetAdminUsersParams): Promise<GetAdminUsersResponse> {
        const token = adminTokenService.getAdminToken();
        try {
            const response = await api.get<GetAdminUsersResponse>(
                "/admin/get-users",
                {
                    params,
                    headers: {
                        Authorization: `${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching admin users:", error);
            throw error;
        }
    }

    /**
     * Creates a new admin user.
     * @param data User data including roles.
     */
    async createUser(data: CreateUserData): Promise<{ statusCode: number; message: string }> {
        const token = adminTokenService.getAdminToken();
        try {
            const response = await api.post<{ statusCode: number; message: string }>(
                "/admin/create-user",
                data,
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error creating admin user:", error);
            throw error;
        }
    }

    /**
     * Updates an existing admin user data.
     */
    async updateUserData(data: UpdateUserData): Promise<{ statusCode: number; message: string }> {
        const token = adminTokenService.getAdminToken();
        try {
            const response = await api.post<{ statusCode: number; message: string }>(
                "/admin/update-user-data",
                data,
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error updating admin user:", error);
            throw error;
        }
    }

    /**
     * Changes an admin user status.
     */
    async changeUserStatus(data: ChangeUserStatusData): Promise<{ statusCode: number; message: string }> {
        const token = adminTokenService.getAdminToken();
        try {
            const response = await api.post<{ statusCode: number; message: string }>(
                "/admin/change-user-status",
                data,
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error changing user status:", error);
            throw error;
        }
    }
}


export const adminUserService = new AdminUserService();
